import React, { useEffect, useState } from "react";
import { Table, Space, Button, Row, Col, Select, Tag, Modal, notification, Tooltip, Pagination } from "antd";
import { FilePdfOutlined, DeleteOutlined, EditOutlined, } from "@ant-design/icons";
import { dropdownService, expenseVoucherService, vendorService, } from "../../../../../services";
import AddExpense from "./AddExpense";
import PayablePayment from "./PayablePayments";
import EditExpense from "./EditExpense";
import { Link } from "react-router-dom";
import { changeDocumentTitle } from "../../../../../utils/title";

function ExpenseVoucher() {

  const [banks, setBanks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [vouchers, setVouchers] = useState([]);
  const [expenseAcc, setExpenseAcc] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [subAccount, setSubAccount] = useState([]);
  const [paymentmodes, setPaymentmodes] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const [isModalShow, setIsModalShow] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [voucher_number, setVoucher_number] = useState(null);
  const [refresh, setRefresh] = useState(true);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [editRecord, setEditRecord] = useState(null);

  const openModal = () => setIsModalOpen(true);

  const showModal = () => setIsModalShow(true);

  const handleEdit = async (record) => {
    setEditModal(true);
  };

  const options = [
    {
      value: "10",
      label: "10",
    },
    {
      value: "25",
      label: "25",
    },
    {
      value: "50",
      label: "50",
    },
  ];

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Voucher Number",
      dataIndex: "voucher_number",
      key: "voucher_number",
    },
    {
      title: "Expense Account",
      dataIndex: ["expense_category", "name"],
      key: "expense_category",
    },
    {
      title: "Expense Sub Account",
      dataIndex: ["expense_sub_category", "name"],
      key: "expense_sub_category",
    },
    {
      title: "Vendor",
      dataIndex: "vendor_name",
      key: "vendor_name",
    },
    {
      title: "Vendor Invoice",
      dataIndex: "vendor_invoice_no",
      key: "vendor_invoice_no",
    },
    {
      title: "Amount($)",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Booking Container",
      dataIndex: "booking_container",
      key: "booking_container",
      render: (text, record) => (
        <>
          {record.booking_number} <br /> {record.container_number}
        </>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => (
        <Tag
          type="primary"
          size="small"
          style={{
            backgroundColor:
              record.is_paid === 0
                ? "yellow"
                : "#1fd655",
            color: record.is_paid === 0 ? "black" : "white",
          }}
        >
          {record.is_paid === 0 ? "Payable" : "Paid"}
        </Tag>
      ),
    },
    {
      title: "Action",
      key: "Action",
      fixed: "right",
      render: (text, record) => (
        <Space size="small">
          <Tooltip title='Edit'>
            <EditOutlined onClick={() => {
              setEditRecord(text);
              handleEdit(text);
            }} />
          </Tooltip>


          <Link to={`/accounts/expense-vouchers/PDF/${record.id}`} className="hover:text-primary">
            <Tooltip title='Pdf'>
              <FilePdfOutlined />
            </Tooltip>
          </Link>

          <Tooltip title='Delete'>
            <DeleteOutlined onClick={() => {
              setSelectedRecord(record.id);
              setDeleteModal(true);
            }} />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const handleDelete = async () => {
    setLoading(true);
    const response = await expenseVoucherService.deleteExpense(selectedRecord);
    if (response.success) {
      notification.success({
        message: "Deleted Successfully!",
        description: response.message,
        placement: "topRight",
      });
    }
    initialize(pagination.current, pagination.pageSize);
    setLoading(false);
    setSelectedRecord(null);
    setDeleteModal(false);
  };

  const initialize = async (page = 1, pageSize = pagination.current) => {
    setLoading(true);
    const { success, data } = await expenseVoucherService.fetch(page, pageSize);
    if (success) {
      setVouchers(data.data);
      setPagination((prev) => ({
        ...prev,
        total: data.total,
        current: page,
        pageSize,
      }));
    }
    setVoucher_number(Number(data?.data[0]?.voucher_number ?? 0) + 1);
    setLoading(false);
  };

  const getVendors = async () => {
    const response = await vendorService.fetchAll();
    if (response.success) {
      setVendors(response.data);
    }
  };

  const getExpenseCat = async () => {
    const response = await expenseVoucherService.fetchCategories();
    if (response.success) {
      setExpenseAcc(response.data);
    }
  };
  const getSubAccount = async () => {
    const response = await expenseVoucherService.fetchSubAccounts();
    if (response.success) {
      setSubAccount(response.data);
    }
  };

  const getPaymentModes = async () => {
    const response = await dropdownService.fetchPaymentModes();
    if (response.success) {
      setPaymentmodes(response.data);
    }
  };

  const getCompanies = async () => {
    const response = await dropdownService.fetchCompanies();
    if (response.success) {
      setCompanies(response.data);
    }
  };

  const getBanks = async () => {
    const response = await dropdownService.fetchBanks();
    if (response.success) {
      setBanks(response.data);
    }
  };

  useEffect(() => {
    changeDocumentTitle("Expense Vouchers");
    if (refresh) {
      initialize(pagination.current, pagination.pageSize);
      setEditRecord(null);
    }
    setRefresh(false);
    getVendors();
    getExpenseCat();
    getSubAccount();
    getPaymentModes();
    getCompanies();
    getBanks();
  }, [refresh]);

  return (
    <div
      style={{
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Row align="middle" style={{ padding: '10px' }}>
        <Col xs={24} md={8}>
          <h1 style={{ fontWeight: "bold", margin: 0 }}>Expense Voucher</h1>
        </Col>
        <Col xs={24} md={16} style={{ textAlign: "right" }}>
          <Space wrap>
            <Button type="primary" onClick={showModal}>
              Add New Expense
            </Button>
            <Button type="primary" onClick={openModal}>
              Add Payable Payments
            </Button>
          </Space>
        </Col>
      </Row>
      {/* <Divider style={{ marginTop: 15 }} /> */}

      <AddExpense
        isVisible={isModalShow}
        setIsModalShow={setIsModalShow}
        vendors={vendors}
        subAccount={subAccount}
        expenseAcc={expenseAcc}
        setRefresh={setRefresh}
        voucher_number={voucher_number}
        record={editRecord ? editRecord : undefined}
      />

      {/* Payable Payment Modal */}
      <PayablePayment
        isVisible={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        paymentmodes={paymentmodes}
        banks={banks}
        companies={companies}
        vendors={vendors}
        vouchers={vouchers}
        setRefresh={setRefresh}
      />

      {/* Edit Expense Modal */}
      <EditExpense
        isVisible={editModal}
        setEditModal={setEditModal}
        vendors={vendors}
        subAccount={subAccount}
        expenseAcc={expenseAcc}
        setRefresh={setRefresh}
        voucher_number={voucher_number}
        record={editRecord ? editRecord : undefined}
      />

      {/* Delete Modal */}
      <Modal
        title={<div style={{ textAlign: "center" }}>Confirm</div>}
        open={deleteModal}
        onOk={handleDelete}
        onCancel={() => {
          setSelectedRecord(null);
          setDeleteModal(false);
        }}
        centered
        styles={{
          body: {
            padding: "20px",
          },
        }}
        width={300}
        footer={
          <div className="flex justify-center gap-3">
            <Button
              type="default"
              onClick={() => {
                setSelectedRecord(null);
                setDeleteModal(false);
              }}
              style={{ width: "30%" }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={handleDelete}
              style={{ width: "30%" }}
              loading={loading}
            >
              Confirm
            </Button>
          </div>
        }
      >
        <p style={{ textAlign: "center" }}>
          Are you sure you want to delete this?
        </p>
      </Modal>

      <Table
        columns={columns}
        scroll={{ x: "max-content" }}
        dataSource={vouchers}
        rowKey="id"
        loading={loading}
        style={{ marginTop: "10px" }}
        pagination={false}
        footer={() => (
          <div className="flex justify-between items-center text-xs ">
            <div className=" text-gray-600">
              Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
              {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
              {pagination.total} entries
            </div>
            <Pagination
              current={pagination.current}
              total={pagination.total}
              pageSize={pagination.pageSize}
              showSizeChanger={false}
              onChange={(page) => initialize(page, pagination.pageSize)}
              itemRender={(current, type, originalElement) => {
                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                return originalElement;
              }}
            />
          </div>
        )}
      />
    </div>
  );
}

export default ExpenseVoucher;
